import type { ButtonFileData } from '@vedalib/editor/lib/elements'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import { saveAs } from 'file-saver'
import { useCallback } from 'react'

import { useFileByUsage } from 'utils/files'

import BaseButtonElement from '../BaseButtonElement'
import type { ButtonElementType } from '../buttonTypes'

interface IDefaultButtonElementProps extends React.ComponentProps<ButtonElementType> {
  children: React.ReactNode
}

const DownloadFileElement: React.FC<IDefaultButtonElementProps> = ({
  element,
  styles,
  mode,
  font,
  children,
}) => {
  const label = element?.value?.label

  const actionData = (element.value.actionData || {}) as ButtonFileData

  const fileData = useFileByUsage(actionData.file, FileUsageTypeEnum.common)

  const onClick = useCallback(() => {
    if (fileData) {
      saveAs(fileData?.path || '', `${fileData?.name}`)
    }
  }, [fileData])

  return (
    <BaseButtonElement
      elementId={element.id}
      font={font}
      label={label}
      mode={mode}
      onClick={onClick}
      styles={styles}
    >
      {children}
    </BaseButtonElement>
  )
}

export default DownloadFileElement
